import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import { Link } from '@router/Link';
import { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';

function LoginCard() {
    const { t } = useTranslation('main', { keyPrefix: 'login' });
    const { user, isLoading } = useUser();
    const loginVisible = !isLoading && !user;
    if (loginVisible) {
        return (
            <Container align='center' spacing={12}>
                <Comment align='center'>
                    <Trans ns='main' i18nKey='login.comment' components={{ br: <br/> }} />
                </Comment>
                <Link activityParams={{}}
                    activityName='SignInActivity' >
                    <LoginButton>
                        {t('button')}
                    </LoginButton>
                </Link>
            </Container>
        );
    }
    return (<Fragment/>);
}

const Container = styled(Column)`
    background-color: var(--color-white);
    border-radius: 8px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.10);
    margin: 0 auto 16px;
    max-width: calc(100% - 40px);
    padding: 16px;
    width: calc(100% - 40px);
`;

const LoginButton = styled(Button)`
    height: 36px !important;
    padding: 8px 20px !important;
`;

const Comment = styled(Text)`
    line-height: 22px !important;
`;

export default LoginCard;
